/* WarmBelt Co — legacy enhancement layer.
   The hero gallery, before/after slider, heat-map and all interactions are now
   built natively in lune-theme.js. This file is intentionally inert so it does
   not double-initialise or hijack the premium hero. Kept as a loaded asset so
   layout/theme.liquid references remain valid. */
(function () { 'use strict'; }());
